export default class Locale_FreezePeriodEditor {
	Number: string = "Number";
	FreezePrevious: string = "Freeze Before Today Only";
}